import styled from '@emotion/styled'

import { Image as ImageComponent } from '@/legacy/components/Image'
import {
  CONFIG_PRODUCTS as PRODUCTS_MAPPER,
  type ProductKeys,
} from '@/legacy/components/Products/constants'
import { BodyP } from '@/legacy/components/Typography'

import type { Props } from '../ModernBlogCard'

export default function CardHeader({
  image,
  alt,
  product,
}: Pick<Props, 'image' | 'alt' | 'product'>) {
  return (
    <>
      <Image image={image} alt={alt} />
      <ProductBadge product={product} />
    </>
  )
}

function Image({ image, alt, ...props }: Pick<Props, 'image' | 'alt' | 'className'>) {
  return (
    <div className="blog-card__cover">
      <ImageComponent
        source={image}
        alt={alt}
        layout="responsive"
        width={300}
        height={200}
        aria-hidden
        {...props}
      />
    </div>
  )
}

interface ProductBadgeProps {
  product?: ProductKeys
}

export const Badge = styled.div`
  margin: auto;
  margin-left: 1rem;
  padding: 0.25rem 1.5rem;
  min-width: 3.5rem;
  background-color: rgb(var(--theme-primary));
  text-align: center;
  border-radius: 32rem;
  transform: translateY(-50%);
`

function ProductBadge({ product }: ProductBadgeProps) {
  const productName = product && PRODUCTS_MAPPER[product].name
  return (
    <Badge aria-hidden>
      <BodyP color="light-solid">{productName}</BodyP>
    </Badge>
  )
}
